module.exports = __webpack_public_path__ + "img/adas-hil-4.acc6117f.svg";